import React, { Component } from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Icons from '../../Icons/Icons';
import { LinkContainer } from 'react-router-bootstrap';
import ConfirmBox from '../../../hoc/ConfirmBox';
import { isSet } from '../../../Utils/CommonFunctions';

class Buttons extends Component {
    state = {
        buttonList:this.props.buttonList,
        isConfirmBoxOpen:false,
        buttonData:null,
        content:'',
        event:''
      }
    defaultOnclickHandler(){
      // alert('sss');
    }
    componentDidUpdate(prevProps){
      if(prevProps.buttonList !== this.props.buttonList) {
        this.setState({buttonList:this.props.buttonList});
      }
    }

    toggleConfirmBox = (item) => {
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:item,content:item.content});
    }
    confirmDelete =(item)=>{      
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:item,content:isSet(item?.data?.action_component?.confirmation_message,"")})
    }
    // confirmButtonClick = () => {
    //   // console.log(this.state.buttonData.clickHandler())
    //   this.state.buttonData.clickHandler();
    //   this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:null,content:''});
    // }
    openConfirmBox =()=>{
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:null,content:''})
    }
    confirmButtonClick = () => {
      this.state.buttonData.clickHandler(this.state.event);
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:null,content:'',event:''});
    }

    render () {
      return (
        <Wrp>
          {/*<span className="webViewMenu">
            { this.buttonListHtml(this.state.buttonList,'btn') }
          </span>          
          <span className="mobileViewMenu">
            <div className="btn-group">
            <a className="btn border-default dropdown-toggle hidden-caret btn-border dropdown-menu-right ml-1 mr-1" data-toggle="dropdown" aria-expanded="false">
            <Icons iconType={'EllipsisV'} />
            </a>
            <span className="dropdown-menu dropdown-menu-right" style={{position:'absolute',transform: 'translate3d(-44px, 33px, 0px)', top: '0px',left: '0px',zIndex:'9999',willChange: 'transform'}}>
            { this.buttonListHtmlMobile(this.state.buttonList,'btn') }
            </span>
            </div>
          </span>*/}
          { this.buttonListHtml(this.state.buttonList,'btn') }

          
          <ConfirmBox
            isConfirmBoxOpen={this.state.isConfirmBoxOpen}
            toggleConfirmBox={this.toggleConfirmBox}
            confirmButtonClick={this.confirmButtonClick}
            content={this.state.content}
          />     
        </Wrp>
      )
    }

    

    buttonListHtml = (buttonList,id)=>{
      // console.log("buttonList",buttonList);
      return buttonList.map((item, i) => {
        if(item!=undefined){
          if(item.isButtonGroup && item.isButtonGroup===true){
            let inlineStyle = (item.style)?{...item.style}:{};
            return(
              <div className={item.className} style={inlineStyle} key={i}>
                {this.buttonListHtml(item.list,'buttonGroup')}
              </div>
            )
          }else if(item.isParentElement && item.isParentElement===true){
            return item.parentElement
          }else{
            return(
              (item.access_mode === undefined || item.access_mode === true) ?
                this.singleButtons(item,id+'_'+i)
              : null
            )
          }
        }
        
      });
    }
    isConfirmPopup=(item,e)=>{ 
      e.persist();
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,buttonData:item,content:item.data.action_component.confirmation_message||"",event:e})
    }
    dropDownButtons = (dropDownItem,i)=>{
      let inlineStyle = (dropDownItem.style)?{...dropDownItem.style}:{};
      let style = {...inlineStyle}
      return(
        <span {...dropDownItem.attributes} style={style}>
            {this.buttonListHtml(dropDownItem.buttonList,i)}
        </span>
      )
    }
    
    singleButtons = (item,i)=>{
      const buttonIconClass = {
        cancel:"",
        save:"",
        edit:"Edit",
        createNew:"",
        addNew:"AddPlus",
        delete:"Delete",
        email:"EmailSettings"
     }
      const href = (item.href) ? item.href: "#";
      const confirm=isSet(item?.data?.action_component?.is_confirmation_popup)===true?true:false
          const eventsHandler = {
            onClick:  (item.clickHandler) && confirm ?this.isConfirmPopup.bind(this,item,):(item.clickHandler) ? item.clickHandler : this.defaultOnclickHandler.bind(),
          }
          let inlineStyle = (item.style)?{...item.style}:{};
          
          let style = (item.disabled) ? {pointerEvents:'none',opacity:'0.7'}:{}
          style = {...inlineStyle,...style}
      return(
        <Wrp key={'wrp'+i}>    
          { //DELETE KEY
            ((isSet(item.isConfirm,false)===true || item.svgIcon && item.svgIcon.toLowerCase() === 'delete') || (item.type && item.type.toLowerCase() === 'delete') || (item.name && item.name === 'Delete') ) ?
              <LinkContainer key={i} to={href} onClick={e=>this.confirmDelete(item)} {...item.attributes} style={style}>
                <a style={style} key={`keya-${i}`}>
                  {(item.iconClass && item.iconClass!=='' && item.iconClass!==undefined)?
                      <Wrp><i className={item.iconClass}></i></Wrp>
                  :(item.svgIcon && item.svgIcon!=='' && item.svgIcon!==undefined)?
                    <Icons iconType={item.svgIcon} />
                  :(buttonIconClass[item.type]!=="" && buttonIconClass[item.type]!==undefined) ?  
                      <Icons iconType={buttonIconClass[item.type]} />
                  :""}{item.name}{item.access_mode}
                </a>
              </LinkContainer>
            : <LinkContainer key={i} to={href} {...eventsHandler} {...item.attributes} style={style}>
                {
                  item.nameBeforeIcon && item.nameBeforeIcon === true ?
                    <a style={style} key={`keyb-${i}`}>
                      {item.name}{item.access_mode} 
                      {(item.iconClass && item.iconClass!=='' && item.iconClass!==undefined)?
                          <Wrp><i className={item.iconClass}></i> </Wrp>
                      :(item.svgIcon && item.svgIcon!=='' && item.svgIcon!==undefined)?
                        <Icons iconType={item.svgIcon} />
                      :(buttonIconClass[item.type]!=="" && buttonIconClass[item.type]!==undefined) ?  
                          <Icons iconType={buttonIconClass[item.type]} />
                      :""}
                    </a>
                  :
                  <a style={style} key={`keyc-${i}`}>
                    {(item.iconClass && item.iconClass!=='' && item.iconClass!==undefined)?
                        <Wrp><i className={item.iconClass}></i> </Wrp>
                    :(item.svgIcon && item.svgIcon!=='' && item.svgIcon!==undefined)?
                      <Icons iconType={item.svgIcon} />
                    :(buttonIconClass[item.type]!=="" && buttonIconClass[item.type]!==undefined) ?  
                        <Icons iconType={buttonIconClass[item.type]} />
                    :""}
                    {item.name}{item.access_mode}
                  </a>
                }
                
              </LinkContainer>
          }      
          
          {(item.children)?
              this.dropDownButtons(item.children,'dropDown'+i)
          :''}     
       </Wrp> 
      )
    }

    /*Mobile View Code Start*/
    buttonListHtmlMobile = (buttonList,id)=>{
      return buttonList.map((item, i) => {
        if(item.isButtonGroup && item.isButtonGroup===true){
          // let inlineStyle = (item.style)?{...item.style}:{};
          return(
            this.buttonGroupListHtmlMobile(item.list,'buttonGroup')
          )
        }else if(item.isParentElement && item.isParentElement===true){
          return item.parentElement
        }else{
          return(
            (item.access_mode === undefined || item.access_mode === true) ?
              this.singleButtonsMobile(item,id+'_'+i,'web')
            : null
          )
        }
      });
    }

    buttonGroupListHtmlMobile = (buttonList,id)=>{
      return buttonList.map((item, i) => {
        if(item.children && item.children.buttonList && item.children.buttonList.length > 0){
          // let inlineStyle = (item.style)?{...item.style}:{};
          return(
            this.buttonListHtmlMobile(item.children.buttonList,'buttonGroup')
          )
        }
      });
    }

    singleButtonsMobile = (item,i)=>{
      // const buttonIconClass = {
      //   cancel:"",
      //   save:"",
      //   edit:"Edit",
      //   createNew:"",
      //   addNew:"AddPlus",
      //   delete:"Delete",
      //   email:"EmailSettings"
      // }
      const href = (item.href) ? item.href: "#";
      const eventsHandler = {
        onClick: (item.clickHandler) ? item.clickHandler : this.defaultOnclickHandler.bind(),
      }
      let inlineStyle = (item.style)?{...item.style}:{};
      
      let style = (item.disabled) ? {pointerEvents:'none',opacity:'0.7'}:{}
      style = {...inlineStyle,...style}
      return(
        <Wrp key={'wrp'+i}>          
          <LinkContainer key={i} to={href} {...eventsHandler} {...item.attributes} className="dropdown-item" style={style}>
            {
              <a safdsaf={item.name} key={`keyd-${i}`}>
                {item.name === '' ? item.toolTip : item.name}{item.access_mode}
              </a>
            }
          </LinkContainer>
                 
       </Wrp> 
      )
    }
    /*Mobile View Code End*/
    
}
Buttons.defaultProps = {
  iconClass: '',
  svgIcon: ''
}

export default Buttons;